/**
 * Article share — Copy link button.
 * Reads share URL from [data-sb-share][data-share-url] wrapper.
 * Falls back to execCommand for older browsers.
 */
(function () {
  function initShareCopy(wrapper) {
    if (!wrapper || wrapper.dataset.sbShareInit === '1') return;
    wrapper.dataset.sbShareInit = '1';
    var btn = wrapper.querySelector('[data-sb-share-copy]');
    if (!btn) return;
    var tooltip = btn.querySelector('[data-sb-share-tooltip]');
    var iconLink = btn.querySelector('.sb-share-copy-icon');
    var iconCheck = btn.querySelector('.sb-share-copy-check');
    var url = wrapper.getAttribute('data-share-url') || window.location.href;

    function done(ok) {
      if (ok) {
        if (iconLink) iconLink.setAttribute('hidden', '');
        if (iconCheck) iconCheck.removeAttribute('hidden');
        if (tooltip) tooltip.textContent = 'Link copied';
        btn.classList.add('is-copied');
        setTimeout(function () {
          if (iconLink) iconLink.removeAttribute('hidden');
          if (iconCheck) iconCheck.setAttribute('hidden', '');
          if (tooltip) tooltip.textContent = 'Copy link';
          btn.classList.remove('is-copied');
        }, 2000);
      } else {
        if (tooltip) tooltip.textContent = 'Press Ctrl+C';
      }
    }

    btn.addEventListener('click', function () {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(
          function () { done(true); },
          function () { done(false); }
        );
      } else {
        try {
          var ta = document.createElement('textarea');
          ta.value = url;
          ta.setAttribute('readonly', '');
          ta.style.position = 'absolute';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
          done(true);
        } catch (e) {
          done(false);
        }
      }
    });
  }

  function boot() {
    var wrappers = document.querySelectorAll('[data-sb-share]');
    for (var i = 0; i < wrappers.length; i++) initShareCopy(wrappers[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
